import sizeStyles from "@web.awesome.me/webawesome-pro/dist/styles/component/size.styles.js";
import { css, html } from "lit";
import { hostStyles } from "../styles/host.styles";
import { WmElement } from "./element";

// TODO: support size.
export class WmClearButton extends WmElement {
  static readonly TAG_NAME = "wm-clear-button";

  static styles = [
    hostStyles,
    sizeStyles,
    css`
      button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.25em;
        background: transparent;
        cursor: pointer;
        color: var(--wa-color-text-quiet);
        font: inherit;
        inline-size: 1.5em;
        border: none;
        transition:
          color var(--wa-transition-fast),
          outline-color var(--wa-transition-fast);
        outline: var(--wa-focus-ring-style) var(--wa-focus-ring-width) transparent;
        outline-offset: var(--wa-focus-ring-offset);

        &:hover {
          background: transparent;
          color: var(--wa-color-text-loud);
        }

        &:focus-visible {
          border-radius: var(--wa-form-control-border-radius);
          outline-color: var(--wa-color-focus);
        }
      }
    `,
  ];

  render() {
    return html`
        <button>
          <wa-icon name="circle-xmark" library="system" variant="regular"></wa-icon>
        </button>
      `;
  }
}

customElements.define(WmClearButton.TAG_NAME, WmClearButton);

declare global {
  interface HTMLElementTagNameMap {
    [WmClearButton.TAG_NAME]: WmClearButton;
  }
}
